import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import { TextField } from "@mui/material";
import QuickLinksDataTable from "../components/data-tables/CategoriesDataTable";
import { API } from "../assets/staticData";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
};

export default function QuickLink() {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const formData = new FormData();

  const [data, setData] = useState({
    linkName: "",
    url: "",
  });

  useEffect(() => {
    async function getData() {
      fetch(`${API}/quick-links`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setItems(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleBannerDataChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const upload = () => {
    if (data.linkName !== "" && data.url !== "") {
      formData.append("data", JSON.stringify(data));
      fetch(`${API}/quick-links`, {
        headers,
        method: "POST",
        body: formData,
      })
        .then(() => {
          setData({ linkName: "", url: "" });
          setOpenAdd(false);
          setRefresh(!refresh);
          toast("The Platform was successfully added", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start" }}>Quick Links Settings</h3>
        <div
          className="addC"
          style={{ height: openAdd ? 360 : 50, padding: openAdd ? 20 : 0 }}
        >
          {openAdd && (
            <div
              className="addContent"
              style={{
                marginTop: 10,
                marginBottom: 20,
                display: "flex",
                width: "80%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ width: "85%", height: "100%" }}>
                <div>
                  <TextField
                    label="Link Name"
                    sx={{ width: "100%", mt: 2 }}
                    size="small"
                    value={data.linkName}
                    onChange={(e) =>
                      handleBannerDataChange("linkName", e.target.value)
                    }
                  />
                </div>
                <div>
                  <TextField
                    label="URL"
                    sx={{ width: "100%", mt: 2 }}
                    size="small"
                    value={data.url}
                    onChange={(e) =>
                      handleBannerDataChange("url", e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
          )}
          <div
            className="addBTN"
            onClick={() => (openAdd ? upload() : setOpenAdd(true))}
            style={{ width: openAdd ? "50%" : "100%" }}
          >
            Add a new Quick Link
            <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
          </div>
          {openAdd && (
            <div
              onClick={() => {
                setOpenAdd(false);
                setData({
                  linkName: "",
                  url: "",
                });
              }}
              className="cancelBTN"
            >
              Cancel
            </div>
          )}
        </div>
        <QuickLinksDataTable data={items} />
      </div>
    </div>
  );
}
